import * as React from 'react';
import Slider from 'react-slick';
import { styled } from '../styles/stitches.config';
import { navigate, graphql, useStaticQuery } from 'gatsby';
import ingredientLibrary from '../images/ingredientlibrary.png';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import BackgroundImage from 'gatsby-background-image';

export const BeKindSection = () => {
    const data = useStaticQuery(
        graphql`
          query {
            allFile: file(name: { eq: "bekindtoyourskin" }) {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `
    )

    console.log(data);

    const imageData = data.allFile.childImageSharp.fluid;

    const Section = styled(BackgroundImage, {
        color: 'white',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        flexFlow: 'column wrap',
        height: '600px',
        // backgroundImage: `url(${ingredientLibrary})`,
        // backgroundSize: 'cover',
        fontFamily: '$default',
        padding: '140px 40px',
        alignItems: 'center',
        justifyContent: 'center',
        '@bp1': {
            height: '700px',
            padding: '80px 40px 80px 60px',
            gridTemplateColumns: '1fr',
            // backgroundPosition: '-180px',
        },
        '@bp2': {
            // backgroundPosition: 'center',
        },
        '& h3': {
            fontSize: '16px',
            marginBottom: '12px',
            fontFamily: '$lato',
            textTransform: 'uppercase',
            letterSpacing: '.1em',
        },
        '& h2': {
            fontSize: '60px',
            lineHeight: '1.2',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
        '& p': {
            marginTop: '20px',
            maxWidth: '600px',
            fontFamily: '$lato',
            fontSize: '18px',
            letterSpacing: '0.5px',
            '@bp1': {
                marginTop: '20px',
                fontSize: '18px',
                letterSpacing: '0.5px',
            },
        },
        '& button': {
            marginTop: '24px',
            padding: '14px 40px',
            letterSpacing: '4px',
            fontFamily: 'Arial',
            fontSize: '14px',
            textTransform: 'uppercase',
            // textDecoration: 'underline',
            backgroundColor: 'white',
            color: 'black',
            // height: '48px',
        }
    });

    return (
        <Section fluid={imageData}>
            {/* <BackgroundImage
                fluid={imageData}
            > */}
            <div>
            </div>
            <div>
                <h3>BE KIND TO YOUR SKIN AND</h3>
                <h2>take the gentle approach</h2>
                <button onClick={() => navigate("/products/multi-active-treatment-essence")}>Shop Now</button>
            </div>
            {/* </BackgroundImage> */}
        </Section>
    )
};
